module.exports = __webpack_public_path__ + "img/Wechat.e6515d97.png";